import { useEffect, useState } from "react";
import classes from "./Profile.module.css";
import CommonButton from "../ui/CommonButton/CommonButton";
import { useNavigate, useParams } from "react-router-dom";
import { env } from "../../constants/env";
import axios from "axios";
import { useAuth } from "../../context/AuthContext";
import ProfileDetails from "../ProfileDetails/ProfileDetails";
import { db } from "../../utils/offlineDB";
import { toast } from "react-toastify";

const Profile = () => {
  const navigate = useNavigate();
  const [labData, setLabData] = useState(null);
  const [error, setError] = useState(null);
  const { user, token } = useAuth();

  const { labId: paramLabId } = useParams();
  const labId = paramLabId || user?.labId;
  const userRole = user?.role;

useEffect(() => {
  const fetchLab = async () => {
    try {
      const localLab = await db.offlineLabs.get(labId);

      // 1️⃣ If local exists and is newer → use it
      if (
        localLab &&
        (!localLab.lastSynced ||
          new Date(localLab.timestamp) > new Date(localLab.lastSynced))
      ) {
        console.log("Using newer local lab data");
        setLabData(localLab);
        return;
      }

      // 2️⃣ If offline → use local only
      if (!navigator.onLine) {
        if (localLab) setLabData(localLab);
        return;
      }

      // 3️⃣ Safe to fetch from server
      const res = await axios.get(
        `${env.kataApiUrl}/api/profile/${labId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const lab = res.data;
      setLabData(lab);

      await db.offlineLabs.put({
        ...lab,
        id: lab._id,
        offline: false,
        lastSynced: new Date().toISOString(),
        timestamp: Date.now(),
      });
    } catch (err) {
      console.error("Failed to fetch lab:", err);
      if (!labData) setError("Failed to fetch lab");
    }
  };

  if (labId) fetchLab();
}, [labId, token]);

  if (error) return <div style={{ color: "red" }}>{error}</div>;
  if (!labData) return <div>Loading lab profile...</div>;

  return (
    <div
      className={`${classes.wrapper} ${paramLabId ? classes.fromParams : ""}`}
    >
      <div className="d-flex align-items-center justify-content-between w-100 mb-4">
        <h2 className="m-0">Profile</h2>
        {userRole !== "MINISTRY" && userRole !== "ZAMMSA" && (
          <CommonButton
            title="Edit lab"
            className={classes.buttonStyle}
            onClick={() => navigate("edit-profile")}
          />
        )}
      </div>
      <ProfileDetails labData={labData} />
    </div>
  );
};

export default Profile;
